import { withInstall, withNoopInstall } from '@sgui-plus/utils/with-install'
import Timeline from './src/timeline'
import TimelineItem from './src/timeline-item.vue'

export const SgTimeline = withInstall(Timeline, {
  TimelineItem,
})
export default SgTimeline
export const SgTimelineItem = withNoopInstall(TimelineItem)

export * from './src/timeline'
export * from './src/timeline-item'
